<template>
  <div class="cmp-title g-title" :class="{'white': isWhite}">
    <i class="line line-l"></i>
    <i class="icon icon-l"></i>
    <p class="name-box">
      <span class="name" v-for="i in title">{{i}}</span>
      <!-- <span class="name">{{title}}</span> -->
    </p>
    <i class="icon icon-r"></i>
    <i class="line line-r"></i>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    // 文字是否为白色
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.cmp-title {
  display: flex;
  align-items: center;
  justify-content: center;
  .line {
    // width: 410px;
    flex: 1;
    height: 1px;
    border-top: dashed 1px #cbcbcb;
  }
  .icon {
    width: 26px;
    height: 35px;
    background: url(~@images/g-title-icon.svg) no-repeat center center;
    background-size: 100%;
    &.icon-l {
      margin: 0 22px 0 4px;
    }
    &.icon-r {
      margin: 0 4px 0 22px;
      transform: rotate(180deg);
    }
  }
  .name-box {
    position: relative;
    // background: url(~@images/1.svg) repeat-x;
    // background-position-x: -1px;
    // background-size: 70px 70px;
    // border: solid 1px #B29550;
    border-top: none;
    border-bottom: none;
    .name {
      display: inline-block;
      text-align: center;
      position: relative;
      width: 70px;
      height: 70px;
      line-height: 70px;
      font-size: 34px;
      color: #343434;
      background: url(~@images/g-title-name-bg.svg);
      background-size: 100% 100%;
      position: relative;
      margin-left: -1px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  // .name-box {
  //   position: relative;
  //   background: url(~@images/1.svg) repeat-x;
  //   background-position-x: -1px;
  //   background-size: 70px 70px;
  //   // border: solid 1px #B29550;
  //   border-top: none;
  //   border-bottom: none;
  //   .name {
  //     width: calc(100% - 18px);
  //     height: 100%;
  //     font-size: 34px;
  //     letter-spacing: 35px;
  //     line-height: 70px;
  //     color: #343434;
  //     font-weight: bold;
  //     position: relative;
  //     right: -18px;
  //   }
  // }

  // 白色的标题
  &.white {
    .line {
      border-top-color: #7B6F5E;
      // border-top-color: #efd6b9;
    }
    .name-box {
      .name {
        color: #fff;
        background: url(~@images/g-title-name-bg-2.svg);
        background-size: 100% 100%;
      }
    }
  }
}
</style>


